<template>
<div class="page-container">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title">财务系统</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>用户对账查询</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content" shadow="never">
    <div style="float: left">
    <div class="page-actions">
      <el-autocomplete
        class="inline-input"
        v-model="coinType"
        :fetch-suggestions="querySearch"
        placeholder="请输入币种">
        <i
          class="el-icon-close el-input__icon"
          slot="suffix"
          @click="cleanSearchCoin"
          style="cursor:pointer;">
        </i>
      </el-autocomplete>
      <el-input placeholder="请输入用户ID" clearable v-model="userId">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-date-picker
          type="datetimerange"
          value-format="timestamp"
          v-model="timeRange"
          start-placeholder="起始时间"
          end-placeholder="终止时间"
      >
      </el-date-picker>
      <el-button @click="handleSearchResult" type="primary">搜索</el-button>
      <el-button @click="handleSearchResultClear" type="">重置</el-button>
      <div class="preview-opration" style="float: right;;right: 0px; white-space:nowrap">
        <download-excel
            class="export-excel-wrapper"
            :data="this.getDetailsForm()"
            :fields="excelData.json_fields"
            :header="excelData.title"
            name="用户对账查询.xls"
            :before-generate="beforeGenerate"
        >
          <el-button type="success">导出</el-button>
        </download-excel>

      </div>
      </div>

    </div>
    <div>
      <el-table
          class="coin-table"
          :data="addressList"
          :row-key="() => Math.random()"
          style="width: 100%"
      >
        <el-table-column label="用户Id" prop="uid"></el-table-column>
        <el-table-column label="币种" prop="coin" ></el-table-column>
        <el-table-column label="总计充值" prop="DEPOSIT_TOTAL" width="100"></el-table-column>
        <el-table-column
            prop="DEPOSIT"
            label="区块链充值"
            width="150"
            :show-overflow-tooltip="true"
            >
          <template slot-scope="scope">
            <router-link :to= "{path: '/fundDetails/walletbill',query: {uid: scope.row.uid ,coinType: scope.row.coin,type:'txr',txtype:1}}">
              <span style="color:#00a0e9;">{{scope.row.DEPOSIT}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="INTERNAL_DEPOSIT"
            label="内部转入"
            width="150"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <router-link :to= "{path: '/fundDetails/walletbill',query: {uid: scope.row.uid ,coinType: scope.row.coin,type:'itxr'}}">
              <span style="color:#00a0e9;">{{scope.row.INTERNAL_DEPOSIT}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column label="系统增加" prop="DEPOSIT_SYSTEM"></el-table-column>
        <el-table-column label="总计提现" prop="WITHDRAW_TOTAL"></el-table-column>
        <el-table-column
            prop="WITHDRAW"
            label="区块链提现"
            width="150"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <router-link :to= "{path: '/fundDetails/walletbill',query: {uid: scope.row.uid ,coinType: scope.row.coin,type:'txr',txtype:-1}}">
              <span style="color:#00a0e9;">{{scope.row.WITHDRAW}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="WITHDRAW_INTERNAL"
            label="内部转出"
            width="150"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <router-link :to= "{path: '/fundDetails/walletbill',query: {uid: scope.row.uid ,coinType: scope.row.coin,type:'itxr'}}">
              <span style="color:#00a0e9;">{{scope.row.WITHDRAW_INTERNAL}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column label="系统减少" prop="WITHDRAW_SYSTEM"></el-table-column>
        <el-table-column label="手续费" prop="FEE"></el-table-column>
        <el-table-column label="当前余额" prop="balance"></el-table-column>
        <el-table-column label="冻结" prop="freeze"></el-table-column>
        <el-table-column label="可用余额" prop="avBalance"></el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalCount" :page-size="indexPagination.size"
                     :current-page.sync="indexPagination.page" @current-change="handlePageChanged"/>
    </div>


  </el-card>
</div>


</template>
<pagination
    :size="pagination.size"
    :page="pagination.page"
    :total="totalCount"
    @pageChanged="handlePageChanged"
></pagination>

<script>
import './store';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';


export default {
  name: 'userstatistics',
  data() {
    return {
      indexPagination:{page:1,size:10},
      userId: '',
      coinType: '',
      address: '',
      memo: '',
      timeRange: [new Date().getTime()-24 * 90 * 60 * 60 * 1000,new Date().getTime()],
      excelData:{
        title:"用户对账",
        json_fields:{
          "用户id":{
            field:'uid',
            callback: value =>{
              return "&nbsp;" + value;
            }
          },
          "币种":{
            field:'coin',
            callback: value =>{
              return "&nbsp;" + value;
            }
          },
          "总计充值":'DEPOSIT_TOTAL',
          "区块链充值":'DEPOSIT',
          "内部转入":'INTERNAL_DEPOSIT',
          "系统增加":'DEPOSIT_SYSTEM',
          "总计提现":'WITHDRAW_TOTAL',
          "区块链提现":'WITHDRAW',
          "内部转出":'WITHDRAW_INTERNAL',
          "系统减少":'WITHDRAW_SYSTEM',
          "手续费":'FEE',
          "当前余额":'balance',
          "冻结":'freeze',
          "可用余额":'avBalance',
        }
      }
    };
  },
  computed: {
    ...mapState('userstatistics', ['addressList', 'allCoins', 'pagination','totalCount'])
  },
  methods: {
    ...mapActions('userstatistics', [
      'list',
      'getAllCoins',
       'clear'
    ]),
    handleSearchResult(data) {
      if (this.timeRange===null){
        alert("查询时间不能为空")
        return;
      }
      this.list({
        uid: this.userId,
        from: this.timeRange[0],
        to: this.timeRange[1],
        coinType: this.coinType,
        ...data.pagination
      });
    },
    handleSearchResultClear(data){
      this.timeRange=[new Date().getTime()-24 * 90 * 60 * 60 * 1000,new Date().getTime()];
      this.userId="";
      this.coinType="";
      this.clear();
    },
    handlePageChanged(currentPage){
      if (this.timeRange===null){
        alert("查询时间不能为空")
        return;
      }
      this.list({
        uid: this.userId,
        from: this.timeRange[0],
        to: this.timeRange[1],
        coinType: this.coinType,
        page:currentPage,
        size:10
      });
    },
    cleanSearchCoin() {
      this.coinType = '';
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.allCoins;
      results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    querySearchChain(queryString, cb){
      var results = [];
      var coinList = ["BEP20","ERC20"];
      results = queryString ? coinList.filter(this.createFilter2(queryString)) : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = ["BEP20","ERC20"];
      return (tempData) => {
        return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    createFilter2(queryString) {
      let tempData = this.allCoins;
      return (tempData) => {
        return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(tab) {
        this.changeTab(tab.name);
    },
    refreshList(data = {}) {
      this.handleSearchResult(data);
    },
    getDetailsForm(){
      return this.addressList;
    },
    beforeGenerate(){
      if (this.getDetailsForm().length<1){
        alert("无数据导出")
      }
    }
  },
  created() {
    this.getAllCoins();
    this.handleSearchResultClear();
  }
};
</script>

<style lang="less" scoped>
</style>





